module.exports = __webpack_public_path__ + "img/checkbox-selected.f7f50386.svg";